import { jsxs as g, jsx as t, Fragment as G } from "react/jsx-runtime";
import { c as _, I as D, S as M } from "./Section-DOeCOW54.js";
import O, { useState as I, useEffect as F, useRef as z, Fragment as V, useMemo as ae } from "react";
import { P as se } from "./Picture-JvtjNict.js";
import { u as X, B as j, I as ee, T as Y } from "./useMediaQuery-BZAMobKw.js";
import { F as E } from "./FlexContainer-CoykMrGV.js";
import { L } from "./Link-CIq4S2Kd.js";
import { T as ce } from "./TextHtml-Cpd1SvM0.js";
import { C as ue } from "./Chip-D9KeDlTM.js";
const de = {
  isMobile: {
    from: 0,
    to: 600
  },
  isTablet: {
    from: 601,
    to: 1024
  },
  isDesktop: {
    from: 1025,
    to: 1 / 0
  }
}, he = (p = de) => {
  const [n, c] = I(0);
  F(() => {
    const a = () => {
      const e = window.innerWidth;
      c(e);
    };
    return a(), window.addEventListener("resize", a), () => {
      window.removeEventListener("resize", a);
    };
  }, []);
  const r = {
    isMobile: !1,
    isTablet: !1,
    isDesktop: !1
  };
  for (const a in p) {
    const e = p[a];
    r[a] = n >= e.from && n <= e.to;
  }
  return r;
}, pe = () => {
  const [p, n] = I(!1), c = z(null), r = X("(max-width: 1023px)"), a = () => {
    c.current && !c.current.contains(document.activeElement) ? n(!1) : n(!0);
  }, e = (h) => {
    c.current && !c.current.contains(h.target) ? n(!1) : n(!0);
  };
  return F(() => {
    r && c.current && n(!0);
  }, [r, c.current]), F(() => {
    const h = () => a(), v = (s) => e(s);
    return document.addEventListener("focusin", h), document.addEventListener("click", v), () => {
      document.removeEventListener("focusin", h), document.removeEventListener("click", v);
    };
  }, []), { visible: p, wrapperRef: c, setVisible: n };
}, me = () => {
  const [p, n] = I(!1), c = z(null), r = X("(max-width: 1023px)"), a = z(null), e = (u) => {
    u.key === "Escape" && n(!1), u.key === "Enter" && p ? n(!1) : u.key === "Enter" && !p && (n(!0), setTimeout(() => {
      a.current && a.current.focus();
    }, 0));
  }, h = (u, d) => {
    var m, w, o, f;
    if (u.key === "ArrowDown" || u.key === "ArrowRight") {
      u.preventDefault();
      const i = (m = document.activeElement) == null ? void 0 : m.nextElementSibling;
      i ? i.focus() : (w = d.firstElementChild) == null || w.focus();
    } else if (u.key === "ArrowUp" || u.key === "ArrowLeft") {
      u.preventDefault();
      const i = (o = document.activeElement) == null ? void 0 : o.previousElementSibling;
      i ? i.focus() : (f = d.lastElementChild) == null || f.focus();
    }
  }, v = (u) => {
    c.current && c.current.contains(u.target) && setTimeout(() => {
      n((d) => !d);
    }, 50);
  }, s = () => {
    c.current && !c.current.contains(document.activeElement) && n(!1);
  };
  return F(() => {
    r && c.current && n(!0);
  }, [r, c.current]), F(() => {
    const u = (w) => v(w), d = () => s(), m = c.current;
    return m && (m.addEventListener("keydown", d), m.addEventListener("click", u)), () => {
      m && (m.removeEventListener("click", u), m.removeEventListener("keydown", d));
    };
  }, []), { visible: p, wrapperRef: c, handleKeyDown: e, firstElementRef: a, setVisible: n, handleArrowKeys: h };
}, fe = "elo-header", we = "elo-mobile", ve = "elo-desktop", ge = "elo-header__content", ye = "elo-section", be = "elo-header__overflow", ke = "elo-button", _e = "elo-tablet", Ce = "elo-opened", Ne = "elo-active", xe = "elo-link", Ee = "elo-link__main", Ae = "elo-title", Se = "elo-flex", De = "elo-submenu", l = {
  "full-width-hero": "elo-full-width-hero",
  header: fe,
  "header-mobile": "elo-header-mobile",
  mobile: we,
  "header-desktop": "elo-header-desktop",
  desktop: ve,
  "header-desktop--no-hero": "elo-header-desktop--no-hero",
  "header-wrapper": "elo-header-wrapper",
  header__content: ge,
  "header-nav": "elo-header-nav",
  "header-dropdown": "elo-header-dropdown",
  "icon-link--secondary": "elo-icon-link--secondary",
  "icon-link--primary": "elo-icon-link--primary",
  "header__top-buttons": "elo-header__top-buttons",
  "header__top-button": "elo-header__top-button",
  "header__inner-content": "elo-header__inner-content",
  section: ye,
  header__overflow: be,
  "header__overflow--active": "elo-header__overflow--active",
  "search-wrapper-container-mobile": "elo-search-wrapper-container-mobile",
  button: ke,
  tablet: _e,
  "search-wrapper-container-mobile-content": "elo-search-wrapper-container-mobile-content",
  "main-menu-container": "elo-main-menu-container",
  "content-wrapper": "elo-content-wrapper",
  opened: Ce,
  active: Ne,
  link: xe,
  link__main: Ee,
  title: Ae,
  "search-container-mobile": "elo-search-container-mobile",
  "search-box": "elo-search-box",
  "search-result-wrapper": "elo-search-result-wrapper",
  "search-icon": "elo-search-icon",
  "search-active": "elo-search-active",
  "search-button": "elo-search-button",
  "special-offset": "elo-special-offset",
  "header-mobile--mobile-no-hero": "elo-header-mobile--mobile-no-hero",
  "header-content-mobile": "elo-header-content-mobile",
  "button-container-mobile-correction": "elo-button-container-mobile-correction",
  "special-button-mobile": "elo-special-button-mobile",
  "special-button": "elo-special-button",
  "user-icon": "elo-user-icon",
  "closed-header": "elo-closed-header",
  "submenu-wrapper-mobile": "elo-submenu-wrapper-mobile",
  "submenu-wrapper-mobile__active": "elo-submenu-wrapper-mobile__active",
  "header-content": "elo-header-content",
  "header-dropdown__chip--active": "elo-header-dropdown__chip--active",
  "header-dropdown-list": "elo-header-dropdown-list",
  "active-lang": "elo-active-lang",
  "header-nav__no-hero": "elo-header-nav__no-hero",
  "header-nav-wrapper": "elo-header-nav-wrapper",
  "logo-link": "elo-logo-link",
  flex: Se,
  "header-nav-wrapper-mobile": "elo-header-nav-wrapper-mobile",
  "main-link": "elo-main-link",
  "submenu-wrapper": "elo-submenu-wrapper",
  "submenu-wrapper__active": "elo-submenu-wrapper__active",
  "buttons-group": "elo-buttons-group",
  "home-icon": "elo-home-icon",
  "submenu-items-wrapper": "elo-submenu-items-wrapper",
  submenu: De,
  "level-link": "elo-level-link",
  "level-2": "elo-level-2",
  "level-2__active": "elo-level-2__active",
  "level-3": "elo-level-3",
  "level-4": "elo-level-4",
  "level-3__active": "elo-level-3__active",
  "level-4__active": "elo-level-4__active"
}, R = 11, Q = 4, J = Q - 1, Le = (p, n) => O.useMemo(() => {
  var v;
  const c = (v = p[n]) == null ? void 0 : v.items;
  if (!c)
    return null;
  const r = Array.from(
    { length: Q },
    () => []
  ), a = (s) => s.reduce(
    (u, d) => u + (d.items ? d.items.reduce(
      (m, w) => m + (w.items ? w.items.length + 1 : 1),
      d.items.length + 1
    ) : 1),
    0
  ), e = (s, u) => {
    let d = 0;
    s.forEach((m) => {
      const w = m.items ? m.items.reduce(
        (o, f) => o + (f.items ? f.items.length + 1 : 1),
        m.items.length + 1
      ) : 1;
      a(r[d]) + w > R && d < u - 1 && d++, r[d].push(m);
    });
  };
  if (e(c, J), r.slice(0, J).some((s) => a(s) > R)) {
    r.forEach((d, m) => r[m] = []), e(c, Q);
    const s = r.flat();
    r.forEach((d, m) => r[m] = []);
    let u = 0;
    s.forEach((d) => {
      r[u].push(d), a(r[u]) >= R && u < Q - 1 && u++;
    });
  }
  const h = r.filter((s) => s.length > 0);
  for (; h.length < J; )
    h.push([]);
  return h;
}, [p, n]), Ie = O.forwardRef(
  ({
    navigate: p,
    closeMenu: n,
    closeTitle: c,
    homeTitle: r,
    columnsData: a,
    banner: e,
    activeMenuNavigation: h,
    currentMenu: v,
    isOpen: s,
    tab: u,
    keyDown: d
  }, m) => {
    const [w, o] = I([]);
    let f = e != null && e.imageUrl ? e.imageUrl : "";
    !(e != null && e.imageUrl) && (e != null && e.title || e != null && e.date || e != null && e.link) && (f = "/Content/Vendor/icons/elo-fallback-article-image-2.png");
    const i = a.every(
      (b) => b.every((C) => {
        var k;
        return ((k = C == null ? void 0 : C.items) == null ? void 0 : k.length) === 0;
      })
    ), A = _(l["submenu-wrapper"], {
      [l["submenu-wrapper__active"]]: s
    }), x = f && (e == null ? void 0 : e.title) && (e == null ? void 0 : e.link);
    return F(() => {
      if (i) {
        const b = (N, $) => {
          const H = [];
          for (let y = 0; y < N.length; y += $)
            H.push(N.slice(y, y + $));
          return H;
        }, C = a.flat(), k = b(C, 5);
        for (; k.length < 3; )
          k.push([]);
        o(k);
      }
    }, [a]), /* @__PURE__ */ g(
      E,
      {
        ref: m,
        justifyContent: "space-between",
        alignItems: "flex-start",
        role: "submenu-wrapper",
        "aria-label": "submenu-wrapper",
        className: A,
        direction: "column",
        onKeyDown: d,
        tabIndex: 0,
        id: "submenu-wrapper",
        children: [
          /* @__PURE__ */ g(
            E,
            {
              justifyContent: "space-between",
              alignItems: "baseline",
              className: l["buttons-group"],
              children: [
                /* @__PURE__ */ g(
                  j,
                  {
                    variant: "secondary",
                    onClick: () => p(h),
                    tabIndex: u,
                    id: "tab-target",
                    children: [
                      /* @__PURE__ */ t(
                        D,
                        {
                          name: "Home",
                          width: "14px",
                          height: "14px",
                          className: l["home-icon"]
                        }
                      ),
                      v,
                      " ",
                      r
                    ]
                  }
                ),
                /* @__PURE__ */ g(
                  j,
                  {
                    variant: "secondary",
                    onClick: () => n(),
                    tabIndex: u,
                    children: [
                      c,
                      /* @__PURE__ */ t(D, { name: "Close", width: "20px", height: "20px" })
                    ]
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ g(
            E,
            {
              justifyContent: "space-between",
              alignItems: "flex-start",
              role: "submenu-items-wrapper",
              "aria-label": "submenu-items-wrapper",
              className: l["submenu-items-wrapper"],
              children: [
                !i && a.map((b, C) => /* @__PURE__ */ t(
                  E,
                  {
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    role: "submenu",
                    "aria-label": "submenu",
                    direction: "column",
                    className: l.submenu,
                    children: b.map((k) => /* @__PURE__ */ g(V, { children: [
                      /* @__PURE__ */ t(
                        L,
                        {
                          className: _(
                            l["level-link"],
                            l["level-2"],
                            "label-medium",
                            {
                              [l.active]: window.location.pathname === k.url
                            }
                          ),
                          href: k.url,
                          children: k.title
                        }
                      ),
                      Array.isArray(k.items) && k.items.map((N) => /* @__PURE__ */ g(V, { children: [
                        /* @__PURE__ */ t(
                          L,
                          {
                            className: _(
                              l["level-link"],
                              l["level-3"],
                              {
                                [l.active]: window.location.pathname === N.url
                              }
                            ),
                            href: N.url,
                            children: N.title
                          },
                          N.title
                        ),
                        Array.isArray(N.items) && N.items.map(($) => /* @__PURE__ */ t(
                          L,
                          {
                            className: _(
                              l["level-link"],
                              l["level-4"],
                              {
                                [l.active]: window.location.pathname === $.url
                              }
                            ),
                            href: $.url,
                            children: $.title
                          },
                          $.title
                        ))
                      ] }, N.title))
                    ] }, k.title))
                  },
                  C
                )),
                i && w.map((b, C) => /* @__PURE__ */ t(
                  E,
                  {
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    role: "submenu",
                    "aria-label": "submenu",
                    direction: "column",
                    className: l.submenu,
                    children: b.map((k) => /* @__PURE__ */ t(V, { children: /* @__PURE__ */ t(
                      L,
                      {
                        className: _(
                          l["level-link"],
                          l["level-2"],
                          "label-medium",
                          {
                            [l.active]: window.location.pathname === k.url
                          }
                        ),
                        href: k.url,
                        children: k.title
                      }
                    ) }, k.title))
                  },
                  C
                )),
                a.length < Q && x && /* @__PURE__ */ t(
                  Je,
                  {
                    imageUrl: f,
                    title: e == null ? void 0 : e.title,
                    date: e == null ? void 0 : e.date,
                    link: e == null ? void 0 : e.link,
                    linkText: e == null ? void 0 : e.linkText
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
), te = ({
  title: p,
  isFocused: n = !0,
  language: c,
  api: r,
  autocompleteUrl: a
}) => {
  const e = z(null), { visible: h, wrapperRef: v } = pe();
  F(() => {
    n && (e != null && e.current) && e.current.focus();
  }, [n, e]);
  const [s, u] = I(""), [d, m] = I([]);
  F(() => {
    if (!s) {
      m([]);
      return;
    }
    const f = new AbortController(), i = f.signal, A = async () => {
      try {
        const b = await fetch(
          `${window.location.origin}${r}?query=${s}&language=${c}`,
          { signal: i }
        );
        if (!b.ok)
          throw new Error("Network response was not ok");
        const C = await b.json();
        Array.isArray(C), m(C);
      } catch (b) {
        b.name === "AbortError" ? console.info("Previous request aborted") : console.warn("Fetch error:", b);
      }
    }, x = setTimeout(() => {
      A();
    }, 500);
    return () => {
      clearTimeout(x), f.abort();
    };
  }, [s, c]);
  const w = (f, i) => {
    if (!i) return f;
    const A = new RegExp(`(${i})`, "gi");
    return f.split(A).map(
      (b) => b.toLowerCase() === i.toLowerCase() ? `<b>${b}</b>` : b
    ).join("");
  }, o = (f) => {
    if (f.preventDefault(), !s) return;
    const i = new URLSearchParams({ q: s });
    window.location.href = `${window.location.origin}${a}?${i.toString()}`;
  };
  return /* @__PURE__ */ g(
    E,
    {
      ref: v,
      className: _(l["search-box"], {
        [l["search-active"]]: h
      }),
      children: [
        /* @__PURE__ */ g("form", { onSubmit: (f) => o(f), "aria-label": `${p} form`, children: [
          /* @__PURE__ */ t("label", { htmlFor: "site-search", className: "sr-only", children: p }),
          /* @__PURE__ */ t(
            "input",
            {
              ref: e,
              placeholder: p,
              onChange: ({ target: f }) => u(f.value),
              "aria-label": p,
              name: "site-search"
            }
          ),
          /* @__PURE__ */ t(
            "button",
            {
              className: l["search-icon"],
              type: "submit",
              "aria-label": `${p} button`,
              children: /* @__PURE__ */ t(D, { name: "Search" })
            }
          )
        ] }),
        h && d.length > 0 && /* @__PURE__ */ t(
          E,
          {
            className: l["search-result-wrapper"],
            "aria-expanded": h ? "true" : "false",
            "aria-controls": "search-menu",
            "aria-label": "search-menu",
            children: /* @__PURE__ */ t("ul", { children: d.map((f) => /* @__PURE__ */ t("li", { children: /* @__PURE__ */ t(L, { href: a + f.query, children: /* @__PURE__ */ t(ce, { htmlString: w(f.keyword, s) }) }) }, f.query)) })
          }
        )
      ]
    }
  );
}, Fe = ({
  search: p,
  languages: n,
  navigate: c,
  headButtons: r
}) => {
  var o, f;
  const {
    visible: a,
    wrapperRef: e,
    handleKeyDown: h,
    firstElementRef: v,
    setVisible: s,
    handleArrowKeys: u
  } = me(), d = z(null), m = (o = n == null ? void 0 : n.list) == null ? void 0 : o.find(
    (i) => i.title.toLowerCase().trim() === n.active.toLowerCase().trim()
  ), w = (i, A) => {
    i.key === "Enter" && c(A);
  };
  return F(() => {
    const i = () => {
      a && e.current && !e.current.contains(document.activeElement) && s(!1);
    };
    return document.addEventListener("focusin", i), () => {
      document.removeEventListener("focusin", i);
    };
  }, [e, a, s]), /* @__PURE__ */ t(M, { className: l["header-wrapper"], children: /* @__PURE__ */ g(
    E,
    {
      justifyContent: "flex-end",
      alignItems: "center",
      role: "navigation",
      "aria-label": "main-navigation",
      className: l.header__content,
      children: [
        p && /* @__PURE__ */ t(te, { isFocused: !1, ...p }),
        /* @__PURE__ */ g(
          E,
          {
            justifyContent: "flex-end",
            alignItems: "center",
            role: "navigation",
            "aria-label": "main-navigation",
            className: l["header__inner-content"],
            children: [
              m && /* @__PURE__ */ g(
                "div",
                {
                  ref: e,
                  className: l["header-dropdown"],
                  tabIndex: 0,
                  onKeyDown: (i) => h(i),
                  children: [
                    /* @__PURE__ */ t(
                      ue,
                      {
                        disabled: !1,
                        leftIcon: "Earth",
                        rightIcon: a ? "ArrowUp" : "ArrowDown",
                        isDesktop: !0,
                        tabIndex: -1,
                        className: _({
                          [l["header-dropdown__chip--active"]]: a
                        }),
                        children: m.title
                      }
                    ),
                    a && /* @__PURE__ */ t(
                      "ul",
                      {
                        ref: d,
                        className: l["header-dropdown-list"],
                        "aria-expanded": a ? "true" : "false",
                        "aria-controls": "language-menu",
                        "aria-label": "language-menu",
                        tabIndex: -1,
                        onKeyDown: (i) => d.current && u(i, d.current),
                        children: (f = n == null ? void 0 : n.list) == null ? void 0 : f.map((i, A) => /* @__PURE__ */ t(
                          "li",
                          {
                            ref: A === 0 ? v : null,
                            className: _({
                              [l["active-lang"]]: i.title === m.title
                            }),
                            onClick: () => c(i.url),
                            onKeyDown: (x) => w(x, i.url),
                            tabIndex: 0,
                            children: i.title
                          },
                          i.title
                        ))
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ t("div", { className: l["header__top-buttons"], children: Array.isArray(r) && r.map((i) => /* @__PURE__ */ t(
                ee,
                {
                  variant: i.variant,
                  iconRight: i.icon,
                  href: i.url,
                  className: l["header__top-button"],
                  children: i.title
                },
                i.title
              )) })
            ]
          }
        )
      ]
    }
  ) });
}, $e = O.forwardRef(
  ({
    hideTopLine: p = !1,
    languages: n,
    search: c,
    menu: r,
    banner: a,
    closeTitle: e,
    homeTitle: h,
    headButtons: v,
    navigate: s,
    closeMenu: u,
    opened: d,
    openMenu: m,
    columnsData: w,
    activeMenuItem: o,
    isHero: f
  }, i) => {
    var H;
    let A = "";
    o > -1 && (A = r[o].url);
    const [x, b] = I(null), C = z(null), k = () => {
      setTimeout(() => {
        C.current && C.current.focus();
      }, 0);
    }, N = (y) => {
      var S;
      if (y.key === "Escape") {
        k(), u();
        return;
      }
      if (y.key === "Tab" && C.current && d) {
        const K = Array.from(
          C.current.querySelectorAll(
            "a, button, input, textarea, select, [tabindex]:not([tabindex='-1'])"
          )
        ), W = document.activeElement;
        if ((W == null ? void 0 : W.id) === "submenu-wrapper") {
          K[0] && K[0].focus();
          return;
        }
        if (K.length === 0) {
          ((S = i == null ? void 0 : i.current) == null ? void 0 : S.querySelectorAll("a:not(.elo-logo-link)")[o + 1]) || u();
          return;
        }
        const oe = K[0], ie = K[K.length - 1];
        y.shiftKey ? W === oe && requestAnimationFrame(() => {
          var P;
          const q = (P = i == null ? void 0 : i.current) == null ? void 0 : P.querySelectorAll("a:not(.elo-logo-link)")[o];
          q && q.focus();
        }) : W === ie && (i != null && i.current) && requestAnimationFrame(() => {
          var P;
          const q = (P = i == null ? void 0 : i.current) == null ? void 0 : P.querySelectorAll("a:not(.elo-logo-link)")[o + 1];
          q ? q.focus() : u();
        });
      }
    }, $ = (y, S, K) => {
      if (y.key === "Tab" && d && S === r.length - 1 && x !== S) {
        u();
        return;
      }
      if (y.key === "Tab" && y.shiftKey && d && S === 0) {
        u();
        return;
      }
      y.key === "Enter" ? (y.preventDefault(), K.items && K.items.length > 0 && x !== S ? (b(S), m(S)) : (u(), b(null))) : y.key === "Escape" && (b(null), u()), y.key === "Tab" && d && x === S && !y.shiftKey && (y.preventDefault(), k(), setTimeout(() => {
        N(y);
      }, 0));
    };
    return /* @__PURE__ */ g(V, { children: [
      !p && /* @__PURE__ */ t(
        Fe,
        {
          navigate: s,
          headButtons: v,
          languages: n,
          search: c
        }
      ),
      /* @__PURE__ */ g(
        M,
        {
          className: _(l["header-nav"], {
            [l["header-nav__no-hero"]]: !f
          }),
          onMouseLeave: () => {
            u(), sessionStorage.setItem("mouseOverNav", "false");
          },
          children: [
            /* @__PURE__ */ g(
              E,
              {
                className: l["header-nav-wrapper"],
                justifyContent: "space-between",
                alignItems: "center",
                role: "menu-navigation-wrapper",
                "aria-label": "menu-navigation-wrapper",
                ref: i,
                children: [
                  /* @__PURE__ */ t(L, { href: "/", className: l["logo-link"], children: /* @__PURE__ */ t(D, { name: "EloLogo", width: "56px", height: "56px" }) }),
                  /* @__PURE__ */ t(
                    E,
                    {
                      justifyContent: "center",
                      alignItems: "center",
                      role: "menu-navigation",
                      "aria-label": "menu-navigation",
                      children: r.map((y, S) => /* @__PURE__ */ g(
                        L,
                        {
                          href: y.url,
                          className: _(l["main-link"], {
                            [l.active]: window.location.href.toLocaleLowerCase().includes(y.url.toLocaleLowerCase()),
                            [l.opened]: d && o === S
                          }),
                          onMouseEnter: () => {
                            sessionStorage.getItem("mouseOverNav") !== "true" && (y.items && y.items.length > 0 ? (m(S), sessionStorage.setItem("mouseOverNav", "true")) : u());
                          },
                          onMouseLeave: () => {
                            sessionStorage.setItem("mouseOverNav", "false");
                          },
                          onKeyDown: (K) => {
                            $(K, S, y);
                          },
                          role: "menu-item",
                          children: [
                            y.title,
                            y.items && y.items.length > 0 && /* @__PURE__ */ t(D, { name: "ArrowDown", width: "24px", height: "24px" })
                          ]
                        },
                        y.title
                      ))
                    }
                  )
                ]
              }
            ),
            Array.isArray(w) && w.length > 0 && /* @__PURE__ */ t(
              Ie,
              {
                ref: C,
                navigate: s,
                closeMenu: u,
                closeTitle: e,
                homeTitle: h,
                columnsData: w ?? [],
                banner: a,
                activeMenuNavigation: A,
                currentMenu: ((H = r[o]) == null ? void 0 : H.title) ?? "",
                isOpen: d && Array.isArray(w),
                tab: 0,
                keyDown: N,
                "aria-expanded": d ? "true" : "false",
                "aria-controls": "main-nav-menu",
                "aria-label": "main-nav-menu"
              }
            )
          ]
        }
      )
    ] });
  }
), Ke = "elo-accordion", Te = "elo-opened", je = "elo-switcher", ze = "elo-closed", qe = "elo-active", Oe = "elo-separator", He = "elo-title", We = "elo-desktop", T = {
  accordion: Ke,
  opened: Te,
  "title-wrapper": "elo-title-wrapper",
  switcher: je,
  "full-switcher": "elo-full-switcher",
  closed: ze,
  "content-wrapper": "elo-content-wrapper",
  active: qe,
  "mobile-level-1": "elo-mobile-level-1",
  separator: Oe,
  title: He,
  desktop: We
}, re = ({
  className: p = "",
  children: n,
  title: c,
  titleLink: r,
  buttonIcon: a,
  titleClass: e = "",
  separateTitleAndIconBehaviour: h,
  contentClass: v = "",
  isOpen: s = !1,
  keyDown: u = () => {
  },
  tabIndex: d,
  ...m
}) => {
  const [w, o] = I(s);
  return F(() => {
    o(s);
  }, [s]), /* @__PURE__ */ g(
    E,
    {
      justifyContent: "space-between",
      alignItems: "center",
      className: _(
        T.accordion,
        "accordion-container",
        p,
        {
          [T.opened]: w,
          [T.closed]: !w
        },
        {
          "opened-state": w,
          "closed-state": !w
        }
      ),
      direction: "column",
      ...m,
      children: [
        /* @__PURE__ */ t(
          E,
          {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            className: _(
              T["title-wrapper"],
              "title",
              e,
              {
                [T.active]: r === window.location.pathname
              }
            ),
            children: h ? /* @__PURE__ */ g(G, { children: [
              /* @__PURE__ */ t(
                L,
                {
                  className: T.title,
                  href: r,
                  tabIndex: d,
                  children: c
                }
              ),
              /* @__PURE__ */ t("div", { className: T.separator }),
              /* @__PURE__ */ t(
                j,
                {
                  className: T.switcher,
                  onClick: () => o(!w),
                  tabIndex: d,
                  onKeyDown: u,
                  children: /* @__PURE__ */ t(
                    D,
                    {
                      name: a,
                      height: "24px",
                      width: "24px"
                    }
                  )
                }
              )
            ] }) : /* @__PURE__ */ g(
              j,
              {
                className: _(
                  T["full-switcher"],
                  e
                ),
                onClick: () => o(!w),
                onKeyDown: u,
                children: [
                  c,
                  /* @__PURE__ */ t(D, { name: a })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          E,
          {
            justifyContent: "space-between",
            alignItems: "center",
            direction: "column",
            className: _(
              T["content-wrapper"],
              v,
              "content-wrapper",
              {
                [T.opened]: w
              }
            ),
            children: n
          }
        )
      ]
    }
  );
}, Pe = 200, Ue = 56, Z = 2.5 * 16, B = 24 * 2, Ve = (p, n) => {
  const [c, r] = O.useState(0), a = Pe * p + Ue + B + Z * (p - 1), e = he({
    isMobile: { from: 0, to: 599 },
    isTablet: { from: 600, to: c || a },
    isDesktop: { from: c || a, to: 1 / 0 }
  });
  return F(() => {
    const h = () => {
      if (n != null && n.current) {
        const v = n.current.children, s = n.current.getBoundingClientRect().left, u = B + s * 2;
        if (v.length > 1) {
          const d = v[0];
          let m = 0;
          d && (m = d.getBoundingClientRect().width);
          const w = v[1];
          let o = 0;
          if (w) {
            const f = w.children;
            for (let i = 0; i < f.length; i++)
              o += f[i].getBoundingClientRect().width + Z;
          }
          r(m + o + u);
        }
      }
    };
    return h(), window.addEventListener("resize", h), window.addEventListener("orientationchange", h), () => {
      window.removeEventListener("resize", h), window.removeEventListener("orientationchange", h);
    };
  }, [n]), e;
};
function le({ menu: p, currentPath: n }) {
  const [c, r] = I(
    p.reduce((e, h) => (e[h.title] = n.includes(h.url) && h.url !== "#", e), {})
  );
  return {
    openState: c,
    handleKeyDown: (e) => (h) => {
      h.key === "Enter" && r((v) => ({
        ...v,
        [e]: !v[e]
      }));
    }
  };
}
const ne = ({
  items: p,
  level: n,
  activeLink: c = "",
  tabIndex: r,
  parentOpen: a
}) => {
  const e = window.location.pathname, { openState: h, handleKeyDown: v } = le({
    menu: p,
    currentPath: e
  });
  return /* @__PURE__ */ t(G, { children: p.map((s) => Array.isArray(s.items) && s.items.length ? /* @__PURE__ */ t(
    re,
    {
      buttonIcon: "ArrowDown",
      title: s.title,
      separateTitleAndIconBehaviour: !0,
      titleLink: s.url,
      titleClass: `elo-mobile-level-${n}`,
      isOpen: h[s.title],
      keyDown: v(s.title),
      tabIndex: a ? 0 : -1,
      children: /* @__PURE__ */ t(
        ne,
        {
          items: s.items,
          level: n + 1,
          activeLink: c,
          tabIndex: h[s.title] ? 0 : -1,
          parentOpen: h[s.title]
        }
      )
    },
    s.title
  ) : /* @__PURE__ */ t(
    L,
    {
      className: _(l.link, `mobile-level-${n}`, {
        [l.active]: s.url === e && s.url !== "#"
      }),
      href: s.url,
      tabIndex: r,
      children: s.title
    },
    s.title
  )) });
}, Qe = O.forwardRef(({
  menu: p,
  menuHasScroll: n,
  homeTitle: c,
  languages: r,
  isTablet: a,
  headButtons: e,
  mainHeadButton: h,
  navigate: v,
  activeLink: s = ""
}, u) => {
  const d = window.location.pathname, { openState: m, handleKeyDown: w } = le({ menu: p, currentPath: d });
  return /* @__PURE__ */ g(
    E,
    {
      className: l["search-wrapper-container-mobile"],
      direction: "column",
      children: [
        /* @__PURE__ */ g(
          E,
          {
            className: _(
              l["search-wrapper-container-mobile-content"],
              {
                "has-scroll": n
              }
            ),
            direction: "column",
            ref: u,
            children: [
              p.map((o) => !Array.isArray(o.items) || !o.items.length ? /* @__PURE__ */ t(
                L,
                {
                  className: _(
                    l.link,
                    l.link__main,
                    {
                      [l.active]: o.url === d && o.url !== "#"
                    }
                  ),
                  href: o.url,
                  children: o.title
                },
                o.title
              ) : /* @__PURE__ */ g(
                re,
                {
                  buttonIcon: "ArrowDown",
                  title: o.title,
                  className: l["main-menu-container"],
                  separateTitleAndIconBehaviour: !1,
                  titleClass: "elo-mobile-level-1",
                  isOpen: m[o.title],
                  keyDown: w(o.title),
                  children: [
                    /* @__PURE__ */ g(
                      L,
                      {
                        className: _(
                          l.link,
                          "elo-mobile-level-2",
                          {
                            [l.active]: d === o.url && o.url !== "#"
                          }
                        ),
                        href: o.url,
                        tabIndex: m[o.title] ? 0 : -1,
                        children: [
                          /* @__PURE__ */ t(D, { name: "Home", width: "12px", height: "12px" }),
                          o.title,
                          " ",
                          c
                        ]
                      }
                    ),
                    /* @__PURE__ */ t(ne, { level: 2, items: o.items, activeLink: s, tabIndex: m[o.title] ? 0 : -1, parentOpen: m[o.title] })
                  ]
                },
                o.title
              )),
              r && /* @__PURE__ */ t(
                E,
                {
                  className: "languages",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  children: r.list.map((o, f) => /* @__PURE__ */ g(V, { children: [
                    /* @__PURE__ */ t(L, { href: o.url, children: o.title }),
                    f + 1 < r.list.length && /* @__PURE__ */ t("div", { className: "separator" })
                  ] }, o.title))
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ t(
          E,
          {
            direction: "column",
            className: _(
              "sub-content",
              {
                "has-scroll": n,
                "tablet-size": a
              }
            ),
            children: Array.isArray(e) && (e == null ? void 0 : e.length) > (h ? 1 : 0) && (e == null ? void 0 : e.map((o) => h && o.title === h.title ? null : /* @__PURE__ */ g(
              j,
              {
                variant: o.variant,
                onClick: () => v(o.url),
                children: [
                  o.title,
                  o.icon && /* @__PURE__ */ t(D, { name: o.icon })
                ]
              },
              o.title
            )))
          }
        )
      ]
    }
  );
}), Ge = ({
  search: p,
  searchVisible: n,
  setSearchVisible: c,
  isTablet: r,
  mainHeadButton: a,
  navigate: e,
  opened: h,
  openMenu: v,
  closeMenu: s
}) => /* @__PURE__ */ g(
  E,
  {
    className: _(
      l["header-nav-wrapper"],
      l["header-nav-wrapper-mobile"]
    ),
    justifyContent: "space-between",
    alignItems: "center",
    role: "menu-navigation-wrapper",
    "aria-label": "menu-navigation-wrapper",
    children: [
      /* @__PURE__ */ t(L, { href: "/", className: l["logo-link"], children: /* @__PURE__ */ t(D, { name: "EloLogo", width: "56px", height: "56px" }) }),
      /* @__PURE__ */ g(
        E,
        {
          justifyContent: "center",
          alignItems: "center",
          role: "menu-navigation",
          "aria-label": "menu-navigation",
          className: _(
            l["header-content-mobile"],
            {
              [l["button-container-mobile-correction"]]: !r
            }
          ),
          children: [
            p && /* @__PURE__ */ t(
              j,
              {
                onClick: () => c(!n),
                variant: "ghost",
                small: !0,
                className: _(
                  l["special-button"],
                  {
                    [l["special-button-mobile"]]: !r
                  }
                ),
                children: /* @__PURE__ */ t(D, { name: "Search" })
              }
            ),
            a && /* @__PURE__ */ g(
              j,
              {
                onClick: () => e(a.url),
                variant: "primary",
                className: _({
                  [l["special-button-mobile"]]: !r
                }),
                children: [
                  r ? a.title : null,
                  a.icon && /* @__PURE__ */ t(D, { name: a.icon })
                ]
              }
            ),
            /* @__PURE__ */ t(
              j,
              {
                onClick: () => {
                  if (h) {
                    s();
                    return;
                  }
                  v(-1, !0);
                },
                variant: "ghost",
                className: _(
                  l["special-button"],
                  {
                    [l["special-button-mobile"]]: !r
                  }
                ),
                children: h ? /* @__PURE__ */ t(D, { name: "Close" }) : /* @__PURE__ */ t(D, { name: "Burger" })
              }
            )
          ]
        }
      )
    ]
  }
), Re = ({
  headButtons: p,
  navigate: n,
  isTablet: c,
  search: r,
  opened: a,
  openMenu: e,
  closeMenu: h,
  menu: v,
  languages: s,
  homeTitle: u,
  activeLink: d
}) => {
  const [m, w] = I(!1), o = ae(() => {
    if (Array.isArray(p)) {
      let x = null, b = null, C = null;
      for (let k = 0; k < p.length; k++) {
        const N = p[k];
        if (N.variant === "primary") {
          b = N;
          break;
        }
        N.variant === "secondary" && (x = N), N.variant === "ghost" && (C = N);
      }
      return b || x || C;
    }
    return null;
  }, [p]), f = z(null), [i, A] = I(!1);
  return F(() => {
    let x = null;
    return f.current && (x = new ResizeObserver(() => {
      f.current && A(
        f.current.scrollHeight > f.current.clientHeight
      );
    }), A(
      f.current.scrollHeight > f.current.clientHeight
    ), x.observe(f.current)), () => {
      x && x.disconnect();
    };
  }, [f, a]), /* @__PURE__ */ g(
    E,
    {
      justifyContent: "space-between",
      alignItems: "flex-start",
      role: "submenu-wrapper",
      "aria-label": "submenu-wrapper",
      className: _(l["submenu-wrapper-mobile"], {
        [l["submenu-wrapper-mobile__active"]]: a
      }),
      children: [
        /* @__PURE__ */ t(
          Ge,
          {
            searchVisible: m,
            setSearchVisible: w,
            search: r,
            isTablet: c,
            mainHeadButton: o,
            navigate: n,
            opened: a,
            openMenu: e,
            closeMenu: h
          }
        ),
        m && r && /* @__PURE__ */ t(E, { className: l["search-container-mobile"], children: /* @__PURE__ */ t(
          te,
          {
            language: r == null ? void 0 : r.language,
            title: r == null ? void 0 : r.title,
            api: r == null ? void 0 : r.api,
            autocompleteUrl: r.autocompleteUrl
          }
        ) }),
        a && /* @__PURE__ */ t(G, { children: /* @__PURE__ */ t(
          Qe,
          {
            menu: v,
            menuHasScroll: i,
            homeTitle: u,
            languages: s,
            isTablet: c,
            headButtons: p,
            navigate: n,
            mainHeadButton: o,
            ref: f,
            activeLink: d
          }
        ) })
      ]
    }
  );
}, nt = ({
  hideTopLine: p = !1,
  languages: n,
  search: c,
  menu: r,
  banner: a,
  closeTitle: e,
  homeTitle: h,
  headButtons: v,
  activeLink: s = "",
  isHero: u = !0
}) => {
  const [d, m] = I(!1), [w, o] = I(-1), f = Le(r, w), i = z(null), A = Ve(r.length, i), x = X("(min-width: 1024px)"), b = () => {
    m(!1), setTimeout(() => {
      o(-1);
    }, 300);
  }, C = (N, $ = !1) => {
    if ($) {
      m(!0), o(-1);
      return;
    }
    if (N !== w || !d) {
      m(!0), o(N);
      return;
    }
  }, k = (N) => {
    window.location.href = N;
  };
  return /* @__PURE__ */ g(G, { children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: _(l.header, {
          [l["header-mobile"]]: !x,
          [l["header-desktop"]]: x,
          [l["closed-header"]]: !d,
          [l["header-desktop--no-hero"]]: !u,
          [l["header-mobile--mobile-no-hero"]]: !u
        }),
        children: x ? /* @__PURE__ */ t(
          $e,
          {
            navigate: k,
            closeMenu: b,
            opened: d,
            menu: r,
            closeTitle: e,
            homeTitle: h,
            openMenu: C,
            columnsData: f,
            activeMenuItem: w,
            ref: i,
            headButtons: v,
            hideTopLine: p,
            languages: n,
            search: c,
            banner: a,
            isHero: u
          }
        ) : /* @__PURE__ */ t(G, { children: /* @__PURE__ */ t(
          Re,
          {
            navigate: k,
            closeMenu: b,
            opened: d,
            menu: r,
            closeTitle: e,
            homeTitle: h,
            openMenu: C,
            activeMenuItem: w,
            headButtons: v,
            hideTopLine: p,
            languages: n,
            search: c,
            banner: a,
            isTablet: A.isTablet,
            activeLink: s
          }
        ) })
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        className: _(l.header__overflow, {
          [l["header__overflow--active"]]: d
        }),
        onClick: b
      }
    )
  ] });
}, U = {
  "article-card": "elo-article-card",
  "article-card__image": "elo-article-card__image",
  "article-card__content": "elo-article-card__content",
  "article-card__date": "elo-article-card__date",
  "article-card__link": "elo-article-card__link"
}, Je = O.forwardRef(
  ({ imageUrl: p, title: n, date: c, link: r, linkText: a, ...e }, h) => /* @__PURE__ */ g("article", { ref: h, className: U["article-card"], ...e, children: [
    p && /* @__PURE__ */ t(
      se,
      {
        defaultSrc: p,
        alt: n ?? "",
        wrapperClassName: U["article-card__image"]
      }
    ),
    /* @__PURE__ */ g("div", { className: U["article-card__content"], children: [
      n && /* @__PURE__ */ t(Y, { type: "label", size: "large", children: n }),
      c && /* @__PURE__ */ t(Y, { type: "label", size: "small", extraClass: U["article-card__date"], children: c }),
      r && a && /* @__PURE__ */ t(ee, { variant: "ghost", small: !0, href: r, className: U["article-card__link"], children: a })
    ] })
  ] })
);
export {
  Je as A,
  nt as H
};
